export default __webpack_public_path__ + "static/media/decoDots.06d64e10.svg";